
import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  getGroupCategoryList,
  patchGroupCategoryList,
  addGroupCategoryList,
  delGroupCategoryList
} from '@/api/system'
import { delObjEmptyKey } from '@/utils'
import { AppModule } from '@/store/modules/app'
import { Form as ElForm } from 'element-ui'

@Component({
  name: 'Picsloader'
})
export default class extends Vue {
  @Prop() private attachUrl!: any
  @Prop() private attachName!: any

  private editForm: any = {
    name: '',
    description: ''
  }
  private addForm: any = {
    name: '',
    description: ''
  }
  private rules: any = {
    name: [
      {
        required: true,
        message: 'Please enter a category name',
        trigger: 'blur'
      }
    ]
  }

  get language() {
    return AppModule.language
  }
  private listLoading: any = false
  private list: any = []
  private total = 0
  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 群列表
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        page_size: this.pagesize,
        page: this.currentPage
      }
      delObjEmptyKey(data)
      await getGroupCategoryList(data).then((res: any) => {
        this.list = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (error) {
      this.listLoading = false
    }
  }

  // 关闭弹框
  private close() {
    this.editForm = {
      name: '',
      description: ''
    }
    this.sendMesVisible = false
    this.currentPage = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
    })
  }

  // 保存
  private async save() {
    ;(this.$refs.editForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.listLoading = true
          const data: any = {
            id: this.editData.id,
            name: this.editForm.name,
            description: this.editForm.description
          }
          delObjEmptyKey(data)
          await patchGroupCategoryList(data).then((res: any) => {
            if (this.language === 'en') {
              this.$message({
                message: 'Edit successful!',
                type: 'success'
              })
            }
            if (this.language === 'zh_cn') {
              this.$message({
                message: '编辑成功！',
                type: 'success'
              })
            }
            if (this.language === 'zh_tw') {
              this.$message({
                message: '編輯成功！',
                type: 'success'
              })
            }
            this.close()
            this.listLoading = false
          })
        } catch (error) {
          this.listLoading = false
        }
      } else {
        return false
      }
    })
  }

  // 关闭弹框
  private closeAdd() {
    this.addForm = {
      name: '',
      description: ''
    }
    this.addSendMesVisible = false
    this.currentPage = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
    })
  }

  // 保存
  private async saveAdd() {
    ;(this.$refs.addForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.listLoading = true
          const data: any = {
            ...this.addForm
          }
          delObjEmptyKey(data)
          await addGroupCategoryList(data).then((res: any) => {
            if (this.language === 'en') {
              this.$message({
                message: 'Edit successful!',
                type: 'success'
              })
            }
            if (this.language === 'zh_cn') {
              this.$message({
                message: '编辑成功！',
                type: 'success'
              })
            }
            if (this.language === 'zh_tw') {
              this.$message({
                message: '編輯成功！',
                type: 'success'
              })
            }
            this.closeAdd()
            this.listLoading = false
          })
        } catch (error) {
          this.listLoading = false
        }
      } else {
        return false
      }
    })
  }

  // 绑定商户
  private sendMesVisible: any = false
  private editData: any = {}
  private edit(row) {
    this.editForm.name = row.name
    this.editForm.description = row.description
    this.sendMesVisible = true
    this.editData = row
  }

  // 新增
  private addSendMesVisible: boolean = false
  private add() {
    this.addSendMesVisible = true
  }

  // 删除列表
  private del(row) {
    if (this.language === 'en') {
      this.$confirm('Are you sure to delete it?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.delGroup(row.id)
          }
        }
      })
    }
    if (this.language === 'zh_cn') {
      this.$confirm('确定删除吗？', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.delGroup(row.id)
          }
        }
      })
    }
    if (this.language === 'zh_tw') {
      this.$confirm('確定刪除嗎？', {
        confirmButtonText: '刪除',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.delGroup(row.id)
          }
        }
      })
    }
  }
  // 删除
  private async delGroup(id) {
    try {
      this.listLoading = true
      const params: any = {
        id: id
      }
      await delGroupCategoryList(params).then((res: any) => {
        if (this.language === 'en') {
          this.$message({
            message: 'Delete successful!',
            type: 'success'
          })
        }
        if (this.language === 'zh_cn') {
          this.$message({
            message: '删除成功！',
            type: 'success'
          })
        }
        if (this.language === 'zh_tw') {
          this.$message({
            message: '删除成功！',
            type: 'success'
          })
        }
        this.hadleGetFilesListApi()
        this.listLoading = false
      })
    } catch (error) {
      this.listLoading = false
    }
  }

  private reset() {
    this.currentPage = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
    })
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  mounted() {
    this.hadleGetFilesListApi()
  }

  created() {}
}
